const reducer = (_, action) => {
    switch (action.type) {
        case 'DELETE':
            return {
                type: null,
                content: null,
            };
        case 'SET':
            return { 
                type: action.data.type,
                content: action.data.content,
            };
        default:
            // istanbul ignore next
            throw new Error('Action type must be defined');
    }
};

export default reducer;
